import { Component } from 'react';
import { renderApp } from './utils/utils';
import { Provider } from 'react-redux';
import configureStore from './utils/configure_store';
import reducers from './recipe_search_app/reducers';
import AppWrapper from './recipe_search_app/components/AppWrapper';
import { QueryClientProvider } from '@tanstack/react-query';
import { ModalExitIntentContainer } from '@hungryroot/modal-exit-intent';
import { queryClient } from '@hungryroot/rest';
import { ExperimentOverrides } from '@hungryroot/experiments';
import { BreakpointSizeLarge } from '@hungryroot/tokens';

const store = configureStore(reducers);

/**
 * This component is still in use as of 2025-07-01 by the /recipes/ and /foods/ pages.
 */
class RecipeSearch extends Component {
  render() {
    return (
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <ExperimentOverrides />
          <AppWrapper />
          <ModalExitIntentContainer
            backgroundImage={
              <picture>
                <source
                  media={`(min-width: ${BreakpointSizeLarge})`}
                  srcSet={`/public/img/homepage/exit_intent_desktop.jpg`}
                />
                <img
                  src={`/public/img/homepage/exit_intent_mobile.png`}
                  alt=""
                />
              </picture>
            }
            variantImage={
              <picture>
                <source
                  media={`(min-width: ${BreakpointSizeLarge})`}
                  srcset={'/img/exitIntent/leadExitIntentDesktop.jpg'}
                />
                <img
                  src={'/img/exitIntent/leadExitIntentMobile.jpg'}
                  loading="lazy"
                  decoding="async"
                  alt="lots of different food"
                />
              </picture>
            }
          />
        </Provider>
      </QueryClientProvider>
    );
  }
}

renderApp(<RecipeSearch />, 'recipe-search-app');
